import { Button } from "antd";

const DEFAULT_OPTIONS = [
  { label: "فعال", value: "active" },
  { label: "آرشیو", value: "deleted" },
  { label: "همه", value: "all" },
];

const ModeToggle = ({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
  className = "",
  style,
}) => (
  <div className={`project-mode-toggle ${className}`} style={style}>
    {options.map((option) => (
      <Button
        key={option.value}
        size="small"
        type={value === option.value ? "primary" : "text"}
        onClick={() => onChange(option.value)}
        className="mode-toggle-button"
        style={{ fontWeight: value === option.value ? 600 : 400 }}
      >
        {option.label}
      </Button>
    ))}
  </div>
);

export default ModeToggle;
